<template>
  <div class="flex flex-col place-items-center">
    <img src="../../assets/logo_trans.png" class="h-20 p-4" />
    <div
      class="border border-mi-blue-500 shadow-lg p-8 rounded-lg m-2 max-w-md"
    >
      <FormulateForm class="input" @submit="setpwd">
        <FormulateInput
          type="email"
          name="email"
          v-model="email"
          validation="^required|email"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Email"
          input-class="bg-gray-200 border border-transparent rounded-md w-full px-2 focus:border-mi-blue-600 focus:bg-white placeholder-black placeholder-opacity-100"
          placeholder="Email"
          :validation-messages="{
            required: 'Email is verplicht',
            email: 'Dit is geen valide e-mail',
          }"
        />
        <FormulateInput
          type="password"
          name="password"
          v-model="password"
          :validation="[
            [
              'matches',
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            ],
          ]"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Wachtwoord"
          input-class="bg-gray-200 border border-transparent rounded-md w-full px-2 focus:border-mi-blue-600 focus:bg-white placeholder-black placeholder-opacity-100"
          placeholder="Wachtwoord"
          :validation-messages="{
            matches:
              'Wachtwoord is moet minimaal 8 karakters lang zijn. En moet minimaal 1 kleine letter, 1 hoofletter, 1 getal en 1 speciaal karakter (!@#$%^&*) bevatten.',
          }"
        />
        <FormulateInput
          type="password"
          name="password2"
          v-model="password2"
          validation="^required|confirm:password"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Wachtwoord (controle)"
          input-class="bg-gray-200 border border-transparent rounded-md w-full px-2 focus:border-mi-blue-600 focus:bg-white placeholder-black placeholder-opacity-100"
          placeholder="Wachtwoord"
          :validation-messages="{
            required: 'Wachtwoord is verplicht',
            confirm: 'Wachtwoorden komen niet overeen',
          }"
        />

        <FormulateInput
          label="Aanmaken"
          type="submit"
          input-class="bg-mi-blue-500 text-center rounded-lg text-white w-full mt-4"
        />
      </FormulateForm>
      {{ this.error_msg }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SetPassword",
  data() {
    return {
      email: "",
      password: "",
      password2: "",
      token: this.$route.params.token,
      error_msg: null,
    };
  },
  methods: {
    setpwd: async function () {
      this.error_msg = null;
      let response = await this.$store.dispatch("setPassword", {
        token: this.token,
        email: this.email,
        password: this.password,
      });
      if ("error" in response) {
        this.error_msg =
          "Kan wachtwoord niet instellen. Controleer of het e-mailadres klopt.";
      } else {
        this.error_msg =
          "Wachtwoord succesvol aangemaakt. U wordt doorgestuurd naar de login pagina.";
        setTimeout(() => this.$router.push({ name: "Login" }), 5000);
      }
    },
  },
};
</script>


<style>
.login-wrapper-class {
  @apply block;
}
</style>